import { gql } from '../../__generated__/gql'

export const TOGGLE_SAVE_CHAT_AI_MESSAGE_MUTATION = gql(`
  mutation toggleSaveChatAiMessage(
    $threadId: Int!,
    $messageId: String!
  ) {
      toggleSaveChatAiMessage(
        input: {
          threadId: $threadId,
          messageId: $messageId
        }
      ) {
          chatAiThreadMessage {
            id
            content
            author
            saved
          }
        }
    }
`)
